import { useEffect } from 'react';
import { playScrollTick } from './sfx';

const TICK_PER_PX = 220;        // accumulated wheel delta needed for one tick
const MIN_INTERVAL_MS = 140;    // floor between ticks; protects trackpad streams

/**
 * Emits a wheel-detent click as the user scrolls. Listens to `wheel`
 * events only (touch swipes never fire wheel, so mobile is silent by
 * design). Combines a delta accumulator with a wall-clock floor so a
 * notched mouse and a smooth trackpad both feel right.
 */
export default function ScrollSfxLayer() {
  useEffect(() => {
    let acc = 0;
    let lastTickAt = 0;

    const onWheel = (e: WheelEvent) => {
      // Normalise line-mode deltas to a pixel-ish magnitude.
      const dy = e.deltaMode === 1 ? e.deltaY * 16 : e.deltaY;
      acc += Math.abs(dy);
      if (acc < TICK_PER_PX) return;
      const now = performance.now();
      if (now - lastTickAt < MIN_INTERVAL_MS) {
        acc = 0;
        return;
      }
      lastTickAt = now;
      acc = 0;
      playScrollTick();
    };

    window.addEventListener('wheel', onWheel, { passive: true });
    return () => window.removeEventListener('wheel', onWheel);
  }, []);

  return null;
}
